import contentRedirects from '../Content/redirects';
import contactRedirects from '../Contact/redirects';
import knowledgeRedirects from '../Knowledge/redirects';
import measurementsRedirects from '../Measurements/redirects';
import mealPlanRedirects from '../MealPlan/redirects';
import biometricSettingsRedirects from '../BiometricSettings/redirects';
import goalSettingsRedirects from '../GoalSettings/redirects';
import dietSettingsRedirects from '../DietSettings/redirects';
import mealPlanSettingsRedirects from '../MealPlanSettings/redirects';
import favMealsRedirects from '../FavMeals/redirects';
import activateProductRedirects from '../ActivateProduct/redirects';
import trackerRedirects from '../Tracker/redirects';

const allRedirects = [
  ...contentRedirects,
  ...contactRedirects,
  ...knowledgeRedirects,
  ...measurementsRedirects,
  ...mealPlanRedirects,
  ...biometricSettingsRedirects,
  ...goalSettingsRedirects,
  ...dietSettingsRedirects,
  ...mealPlanSettingsRedirects,
  ...favMealsRedirects,
  ...activateProductRedirects,
  ...trackerRedirects,
];

export default allRedirects;
